import FontBody2 from "../../../../../../../../components/fonts/font-body2/font-body2";
import { FONT_COLOR } from "../../../../../../../../components/fonts/font-props";
import IconInfo from "../../../../../../../../components/icons/icon-info/icon-info";
import Icon from "../../../../../../../../components/icons/icon/icon";
import { Tooltip } from "../../../../../../../../components/tooltip/tooltip";
import './column-title.scss';

interface IProps {
    title: string;
    tooltipText?: string;
}

const ColumnTitle: React.FC<IProps> = ({title, tooltipText}) => {
    if (!tooltipText) {
        return <div className="inactive-rma-cancel-settings-column-title">{ title }</div>;
    }

    return (
        <div className="inactive-rma-cancel-settings-column-title">
            { title }
            <Tooltip content={
                <div className="inactive-rma-cancel-settings-tooltip-text">
                    <FontBody2 color={FONT_COLOR.NEUTRAL_WHITE}>{ tooltipText }</FontBody2>
                </div>
            }>
                <Icon Component={() => <IconInfo color={'var(--color-accent-1)'} />} />
            </Tooltip>
        </div>
    );
}

export default ColumnTitle;